/**
 * TeleTime POS - "this drawer has been open a long time"
 *
 * Surfaced, never auto-closed: closing a shift is a cash count, not something a screen
 * decides. Past 12 hours the expected figure covers more than today's trading, and the
 * cashier should know before counting. The nightly audit job (04:15) logs
 * shift.stale_open past 24 h; this is the earlier, human-facing half.
 *
 * Item 7 P4 wrote this for ShiftClose.jsx — a page nothing imported, so it never once
 * appeared. Shift 31 was open from 2026-09-11 to 2026-09-22 with the POS saying nothing.
 */

import { formatDateTime } from '../../utils/formatters';

export const STALE_SHIFT_HOURS = 12;

/** @returns {number} hours since the shift opened, 0 if unknown */
export function shiftHoursOpen(openedAt) {
  if (!openedAt) return 0;
  const ms = Date.now() - new Date(openedAt).getTime();
  return Number.isFinite(ms) && ms > 0 ? ms / 3_600_000 : 0;
}

/**
 * @param {object} props
 * @param {string} props.openedAt - ISO timestamp the shift opened
 * @param {string} [props.className]
 */
export function StaleShiftNotice({ openedAt, className = '' }) {
  const hours = shiftHoursOpen(openedAt);
  if (hours < STALE_SHIFT_HOURS) return null;

  return (
    <div
      data-testid="stale-shift-notice"
      className={`p-4 bg-amber-50 border border-amber-200 text-amber-900 rounded-lg ${className}`}
    >
      <p className="font-medium">
        Shift open since {formatDateTime(openedAt)} ({Math.floor(hours)} hours)
      </p>
      <p className="text-sm mt-1">
        The expected figure covers the whole of that period, not just today. Check it against
        the drawer before you count.
      </p>
    </div>
  );
}

export default StaleShiftNotice;
